<template>
  <div>
    <div
      class="h-13 flex"
      @mouseover="hoverState = true"
      @mouseleave="hoverState = false"
    >
      <div class="sticky left-80 z-10 pl-6 flex bg-slate-100">
        <div
          class="w-60 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 border-l border-r gap-2 cursor-pointer"
          :class="[
            isLast ? 'rounded-bl' : '',
            hoverState ? 'bg-hover-state' : 'bg-pure-white'
          ]"
          @click="$emit('open-panel')"
        >
          <BlTextBody2
            :title="creditPackageItem.name"
            :text="creditPackageItem.name"
            class="truncate text-slate-1000 underline"
          />
        </div>
      </div>
      <div
        class="w-32 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlChip
          :chip="packageItemChips[creditPackageItem.status].chip"
          :color="packageItemChips[creditPackageItem.status].color"
          dense
        />
      </div>
      <div
        class="w-48 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 justify-between"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2 :text="currentCenter.currency_sym" />
        <BlTextBody2
          :text="priceFormats(creditPackageItem.standard_retail_price)"
        />
      </div>
      <div
        class="w-48 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 justify-between"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2 :text="providers[creditPackageItem.provider]" />
      </div>
      <div
        class="w-100 px-4 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 flex-grow"
        :class="[hoverState ? 'bg-hover-state' : 'bg-pure-white']"
      >
        <BlTextBody2
          :title="creditPackageItem.description"
          :text="creditPackageItem.description || '-'"
          class="truncate whitespace-pre-line"
        />
      </div>
      <div class="sticky right-0 z-10 pr-6 flex bg-slate-100">
        <div
          class="w-16 flex items-center flex-shrink-0 border-b border-slate-400 transition-all duration-300 border-r justify-center"
          :class="[
            isLast ? 'rounded-br' : '',
            hoverState ? 'bg-hover-state' : 'bg-pure-white'
          ]"
        >
          <BlInputButton
            v-if="!creditPackageItem.is_default"
            type="outlined"
            dense
            label="Edit"
            @clicked="editOpened = true"
          />
          <!-- <div class="relative">
            <BlInputButton
              type="plain"
              dense
              icon="dots-vertical"
              class="hover:bg-hover-state"
              @clicked="menuOpened = !menuOpened"
            />
            <div
              v-if="menuOpened"
              class="absolute z-50 top-0 right-full mr-3 py-2 px-2 flex flex-col gap-1 bg-pure-white rounded border border-slate-400"
            >
              <div
                class="px-4 py-2 min-w-64 rounded hover:bg-hover-state cursor-pointer"
                @click="editOpened = true"
              >
                <BlTextBody2 class="text-slate-1000" text="Edit package" />
              </div>
              <div
                class="px-4 py-2 min-w-64 rounded hover:bg-hover-state cursor-pointer"
                @click="deleteOpened = true"
              >
                <BlTextBody2 class="text-error-400" text="Delete package" />
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>

    <EditPackageItemModal
      v-if="editOpened"
      :creditPackageItemId="creditPackageItem.id"
      @close-modal="editOpened = false"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayPrice } from "@/plugins/helper.js";

import EditPackageItemModal from "./EditPackageItemModal.vue";

import BlChip from "../../BlChip.vue";
import BlTextBody2 from "../../BlTextBody2.vue";
import BlInputButton from "../../BlInputButton.vue";

export default {
  name: "PackageItemItem",
  components: {
    EditPackageItemModal,
    //
    BlTextBody2,
    BlChip,
    BlInputButton
  },
  props: {
    creditPackageItem: { type: Object, required: true },
    isLast: { default: false }
    // @open-panel
  },
  data() {
    return {
      hoverState: false,
      //
      packageItemChips: {
        active: { chip: "Active", color: "lime" },
        archived: { chip: "Archived", color: "rose" }
      },
      providers: {
        available_for_everyone: "Available for everyone",
        restricted: "Restricted"
      },
      menuOpened: false,
      editOpened: false
    };
  },
  computed: {
    ...mapGetters(["currentCenter"])
  },
  watch: {
    menuOpened(val) {
      if (val) {
        setTimeout(() => {
          window.addEventListener("click", this.closeHandler);
        }, 10);
      }
    }
  },
  methods: {
    ...mapActions([]),
    displayPrice,
    priceFormats(price = 0) {
      const settings = this.currentCenter.currency_settings;
      return this.displayPrice({ settings, price });
    },
    closeHandler() {
      window.removeEventListener("click", this.closeHandler);
      this.menuOpened = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/center/packageItem/Item.vue